import './index.css';

const Accordion = () => {
    return (
        <>
            <ul className="accordion-ul">
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i className="mg-top-arrow"></i>
                    <h2 className="accordion-title">Pripadanje</h2>
                    <p>
                        Potreba za pripadanjem obitelji, grupi, generaciji, susjedstvu ... je svima poznata i prirodna
                        potreba. Ali pripadanje je i pravo. Ukoliko se to pravo naruši, obiteljska savjest se kroz
                        sistemske utjecaje pobrine da svatko dobije svoje mjesto.
                    </p>
                    <p>
                        Kada je neka osoba u obitelji nedostaje, izopćena je, zatajena ili nije u potpunosti prihvaćena,
                        obiteljska savjest nađe načina da tim članovima da pravo pripadanja kroz utjecaj na živote
                        drugih članova obitelji što se i transgeneracijski prenosi na nove generacije unuka i praunuka.
                        Isključenje utječe ne ako je isključena osoba već i ako su potisnute emocije, zanijekani
                        događaji, tajne... Svako isključenje kroz obiteljsku savjest nađe načina da se kroz nekog člana
                        obitelji ili kroz događaj pokažu i traže pravo na pripadanje.
                    </p>
                    <p>
                        A tko sve pripada obitelji?
                        <ul>
                            <li>Partneri, sadašnji i bivši</li>
                            <li>Braća i sestre, ali ne i njihova djeca i partneri</li>
                            <li>Majka i otac</li>
                            <li>
                                Braćai sestre od oca i majke &#40; stričevi i ujaci, ali ne i njihovi partneri i djeca
                                &#41;
                            </li>
                            <li>Djedovi i bake i njihova braća i sestre</li>
                            <li>I tako dalje....</li>
                        </ul>
                    </p>
                    <p>
                        Obitelji pripadaju i svi oni koji su bitno utjecali na sudbinu obitelji - koji su podupirali ili
                        spašavali živote: posvojitelji, osobe koje su znatno materijalno i duhovno pomagali i podupirali
                        obitelji i slično. Ali i oni koji su koji su oduzimali živote: žrtve i počinitelji pripadaju i u
                        obitelj žrtve i u obitelj počinitelja. Njihovo postojanje treba biti priznato, njhov utjecaj na
                        obitelj prepoznat.
                    </p>
                    <p>
                        Tko najčešće „nedostaje“: prerano umrli članovi, članovi obitelji koji su emigrirali ili
                        napustili obitelj, članovi obitelji koji su zanijekani ili sakriveni ili zatajeni: nerođena
                        djeca, vanbračna djeca, mentalni ili fizički hendkepirani, vanbračni partneri, značajni partneri
                        roditelja, osobe koje su ne neki način osramotile obitelj pa ih se obitelj odrekla, žrtve i
                        počinitelji...
                    </p>
                    <p>
                        U obitelj pripadaju i potisnute emocije vezane uz značajne događaje kao što su rat, glad,
                        siromaštvo, krađe ili nezasluženo stjecanje imovine, seljenje u nova mjesta stanovanja i u nove
                        kulturne zajednice.
                    </p>
                    <p>
                        Na koji se način obiteljska savjest pobrine da svi i sve pripada? Jedan od načina je da se u
                        obitelji kroz više generacija ponavljaju slični ili isti događaji. Ili se pojavljuju kao
                        sklonosti sličnim bolestima, uključujući i mentalne poremećaje. Ili neki mlađi čovjek u obitelji
                        „poprimi“ karakter nekog strica ili ujaka kojeg nikad nije upoznao. Ili osjećamo dug svoje
                        obitelji pa sebi podsvjesno sabotiramo život.
                    </p>
                    <p>
                        Najčešće nosimo potisnute emocije svojih roditelja ili predaka i slijedom toga djelomično
                        ponavljamo njihove sudbine.
                    </p>
                </li>
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i className="mg-top-arrow"></i>
                    <h2 className="accordion-title">Poredak</h2>
                    <p>
                        Poredak ili red u obitelji osigurava da tijek i energija života teče punom snagom i dopire do
                        svih članova obitelji. Kada je taj poredak iz nekog razloga poremećen, tijek životne energije
                        slabi, narušava se sposobnost primanja i davanja. I u obitelji i kod pojedinih članova.
                    </p>
                    <p>
                        Prvo pravilo poretka je da životna energija najbolje teče od starijih prema mlađima , zato oni
                        koji dolaze prije imaju prednost prema onima koji dolaze kasnije. <br />
                        Drugo važno pravilo je da nova obitelj ima prednost pred izvornoj obitelji. kao što biblija
                        kaže: Stoga će čovjek ostaviti oca svog i majku svoju, te prionuti uza ženu svoju, i oni će biti
                        jedno tijelo.
                        <br />
                        Uz to, svako u obitelji ima svoje mjesto i uz to mjesto povezanu ulogu. Posve je prirodno da se
                        ponekad u obitelji privremeno poremeti poredak, nakon većih osobnih bolesti ili trauma, ranih
                        smrti ili prekida partnerstva.
                    </p>
                    <p>
                        U tim slučajevima netko iz obitelji privrermeno preuzme ulogu i „mjesto“ člana kojeg više nema
                        ii koji je nemoćan, kao privremena ispomoć, dok se obitelj ili član obitelji ne oporavi. Ali
                        nakon oporavka je bitno da opet svatko ima svoju ulogu. Nije dobro da privremena ispomoć ostane
                        trajna. Naročito su tome sklona djeca pa i kad odrastu žive tuđe živote.
                    </p>
                    <p>
                        Čest poremećaj u poretku je i parentifikacija, kada djeca imaju potrebu da budu „roditelji“ ocu
                        ili majci ili obojma.
                        <br /> Ili kada u slučaju difunkcionalnog partnerstva sin ili kćer pokušaju zauzeti roditeljsko
                        mjesto u obitelji pa postanu „mamini sinovi“ i „tatine curice“.
                        <br /> Sinovi i kćeri zarobljeni u ulogama koje im ne pripadaju ne žive svoj već tuđi život. Ako
                        i uspiju ostvariti svoje partnerstvo, ono bude opterećeno obavezama prema primarnim obiteljima
                        pa to partnerstvo postane disfunkcionalno.. i proces se dalje ponavlja.
                    </p>
                    <p>
                        Izlazak iz krive uloge je u tri koraka:
                        <ul>
                            <li>osvijestiti svoje „krivo“ mjesto,</li>
                            <li>prihvatiti i poštivati člana obitelji kojeg pokušavate nadomjestiti i</li>
                            <li> preuzeti odgovornost za sebe i samo za sebe.</li>
                            <li> poštivati druge, njihovu sudbinu i živote i prestati im „pomagati“</li>
                        </ul>
                    </p>
                </li>
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i></i>
                    <h2 className="accordion-title">Ravnoteža davanja i primanja</h2>
                    <p>
                        Iako ovaj princip dio konstelatora ne smatra osnovnim principom, ovo pravilo u konstelacijama
                        ima svoju primjenu i prepliće se sa osnovnim principima pripadanja i poretka.
                    </p>
                    <p>
                        U svemu što nam se u životu događa važno je imati ravnotežu davanja i primanja:
                        <ul>
                            <li>
                                Član obitelji daje lojalnost, prihvaćanje pravila i uloga u obitelji. Od obitelji prima
                                osjećaj pripadanja, osjećaj slobode.
                            </li>
                            <li>
                                Roditelj daje život, djeca život prosljeđuju na svoj način dalje. Nema duga prema
                                roditeljima!!
                            </li>
                            <li>
                                Roditelj završava svoju ulogu dajući svojoj djeci puno povjerenje, a djeca odrastu kada
                                prema roditelji izgrade poštovanje bez ikakve zadrške. Kada odrasla djeca ovo pravilo ne
                                poštuju, dolazi do smanjene mogućnosti primanja i davanja. Roditelji instinktivno osjete
                                kada njihova djeca odrastu i tada prestanu biti „gnjavatori“. Do tog vremena,
                                instinktivno zrcale nesigurnosti i nezrelost svoje djece.
                            </li>
                            <li>
                                U partnerstvu nema ravnoteže u davanju i primanju!! Kada partner daje, drugi partner mu
                                uzvrati malo više od onoga što je dobio. I tako ljubav raste. Kada partner povrijedi,
                                drugi partner mu ima pravo uzvratiti ali malo manjom mjerom od onoga čime je povrijeđen.
                                Tako nema žrtve i odnos se sačuva.
                            </li>
                            <li>
                                Opraštanjem se ne dolazi do poravnanja. To je zauzimanje arogantnog stava i stvaranje
                                vječitog duga onome kome opraštaš: „Ja sam bolji od tebe i opraštam ti. Vječno mi
                                duguješ.“
                            </li>
                            <li>
                                Kada je netko povrijeđen, ravnoteža se uspostavlja zadovoljštinom, malo manjom nego što
                                je povreda.
                            </li>
                            <li>
                                Kada nekoga povrijediš, ne tražiš oproštaj. Time sebično samo želiš sebe osloboditi
                                boli. Kada povrijediš, važno je da priznaš bol koju si prouzročio, sebi ili povrijeđenoj
                                osobi. Time oslobađaš onoga kojeg si povrijedio. I ostavljaš mogućnost poravnanja onome
                                koji je bio povrijeđen.
                            </li>
                            <li>
                                Kada nešto dobiješ{' '}
                                <ul>
                                    <li className="third-layer">ili vratiš istom mjerom onome od koga si dobio</li>
                                    <li className="third-layer">ili proslijediš nekome drugome</li>
                                    <li className="third-layer">
                                        ili ako nije moguće, poravnaš sa iskrenom zahvalnošću tako da nema duga.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Kada daješ, daješ samo bezuvjetno. Sve ostalo je trgovina ili stavljanje drugih u
                                dužnički položaj ili stavljanje sebe u položaj većega.
                            </li>
                            <li>
                                Kada se nešto daje, nije nužno da se isto prima nazad ili da se vraća onome od kojeg je
                                dobiveno. Naprimjer Učitelj daje znanje koje je primio od svog učitelja, učenik prima
                                znanje i vraća poštovanje.
                            </li>
                        </ul>
                    </p>
                </li>
            </ul>
        </>
    );
};

export default Accordion;
